import React from 'react'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'

const ChatSpace = () => {
  return (
    <div>
        <ComingSoon />
    </div>
  )
}

export default ChatSpace